// extracted by mini-css-extract-plugin
module.exports = {"header":"reference-menu-module__header___3-ihS","menuContainer":"reference-menu-module__menuContainer___oby7q"};